import { IconFilter } from '@tabler/icons-react'
import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import useLocalStorageState from 'use-local-storage-state'
import { useNavigate } from 'react-router-dom'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import dayjs from 'dayjs'
import relativeTime from "dayjs/plugin/relativeTime"
// relativeTime plugin adds or extends methods like .fromNow() , .toNow(), .from() etc to dayjs. This is how we were able to achieve that time diff
dayjs.extend(relativeTime)

export const RecentActivity = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate()

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const [recentActivityData, setRecentAcitivityData] = useState([])
    const [openFilter, setOpenFilter] = useState(false)
    const filterDropRef = useRef(null)

    const [filter, setFilter] = useState("Today")

    useOutsideClickHandler({
        objRef: filterDropRef,
        isDropdown: openFilter,
        setDropdown: setOpenFilter
    })

    const colors = ["#845adf", "#845adf", "#23b7e5", "#23b7e5", "#6c757d", "#f5b849", "#f5b849", "#26bf94",]
    const randomColor = () => {
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
    };

    const icons = {
        workflow: "fa-solid fa-diagram-project",
        contact: "bi bi-person-badge-fill",
        company: "bx bxs-business",
        lead: "bx bxs-user",
        deal: "fa-solid fa-sack-dollar",

    }

    const fetchActivity = async () => {
        try {
            const lowerCaseFilterValue = filter === "Today" ? "today" : filter?.toLowerCase()?.split(" ")[1];
            const res = await GetRequest(
                `dashboard/fetchActivityData_creation/${customer?.customer_details?.customer_id}/${customer.customer_details?.id}/${customer?.customer_details?.user_type}/${lowerCaseFilterValue}`,
                { headers },
                extras
            )
            if (res?.status === "fail" || res.success === false) {
                setRecentAcitivityData([])
                return
            }
            console.log('data', res.data)
            const data = res.data && res.data?.filter(c => c.count !== 0)?.map(c => {
                return {
                    text: `${c.count} new ${c.module} created.`,
                    time: dayjs(c.created_at).fromNow(),
                    color: randomColor(),
                    icon: icons[c.module]
                }
            })
            setRecentAcitivityData(data)
        } catch (error) {
            return
        }
    }

    useEffect(() => {
        fetchActivity()
    }, [filter])
    return (
        <div className="col-xxl-12 col-xl-12 col-md-12 ">
            <div className="card px-2" >
                <div className=" border-0 d-flex pe-0 pt-0 mt-0 justify-content-between">
                    <span className="addEnquiryHead " style={{ fontWeight: 600, paddingLeft: '2rem' }}>Recent Activity</span>
                    <Dropdown
                        style={{ zIndex: 99, marginTop: "-0.2rem" }}
                        show={openFilter}
                        ref={filterDropRef}
                    >
                        <Dropdown.Toggle
                            as="button"
                            onClick={() => setOpenFilter(prev => !prev)}
                            className="btn btn-light d-flex align-items-center gap-2 px-2 py-1 text-muted no-arrow"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef' }}
                        >
                            <IconFilter size={16} color="#7a3a5e" />
                            {filter}
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow" style={{ zIndex: 9999 }} align={"end"}>
                            <Dropdown.Item onClick={() => {
                                setOpenFilter(false)
                                setFilter("Today")
                            }}>
                                Today
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {
                                setOpenFilter(false)
                                setFilter("Last Week")
                            }}>
                                Last Week
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {
                                setOpenFilter(false)
                                setFilter("Last Month")
                            }}>
                                Last Month
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <hr className='mb-0 mt-2' />
                <div
                    className='px-0 '
                    style={{
                        minHeight: "31.7rem",
                        maxHeight: "31.7rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        width: "100%",
                        paddingRight: "8px",
                        scrollbarWidth: "thin",
                        scrollbarColor: "transparent transparent",
                        transition: "scrollbar-color 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.scrollbarColor = "#888 #f1f1f1"
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.scrollbarColor =
                            "transparent transparent"
                    }}

                >
                    <ul className="list-unstyled position-relative mb-0 px-3 crm-recent-activity" >
                        {recentActivityData?.length !== 0 ?
                            recentActivityData?.map((activity, idx) => (
                                <li
                                    key={idx}
                                    className="crm-recent-activity-content py-3"
                                >
                                    <div className="d-flex align-items-top">
                                        <div className="crm-me-3">
                                            <span
                                                className="avatar d-flex align-items-center justify-content-center avatar-rounded"
                                                style={{
                                                    backgroundColor: activity.color + "20",
                                                    padding: '0.8rem',
                                                    color: 'black',
                                                    width: "1.5rem",
                                                    height: "1.5rem",
                                                }}
                                            >
                                                <i
                                                    className={`${activity.icon}`}
                                                    style={{ color: activity.color }}
                                                ></i>
                                            </span>
                                        </div>
                                        <div className="crm-timeline-content ps-2 ">
                                            <span className="mb-0 text-muted" style={{ fontWeight: 400, fontSize: '1rem', }}>
                                                {activity.text}
                                            </span>
                                        </div>
                                        <div className="flex-fill text-end">
                                            <span className="d-block text-muted fs-12 op-7">
                                                {activity.time}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            ))
                            :
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: "10%", top: "3rem" }}
                            >
                                <img
                                    src={nodata}
                                    alt="nodata_found_img"
                                    style={{ width: "17rem", marginTop: "0" }}
                                />
                            </div>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}
